export const OAUTH_PARAMS_KEY = 'oauth_params';

// Trusted external OAuth redirect targets, each validated server-side against its
// registered client (tbl__oauthapi_clients.redirect_uri). Listed here as defense in
// depth so the frontend only navigates to known callbacks.
// One entry per external integration.
export const OAUTH_TRUSTED_REDIRECTS = [
  // Google Sheets Apps Script - prod.
  'https://script.google.com/macros/d/1Vt6FXCHEq_ERBVRUHlfz8F4w_N5nohMjcYG613v2calINonUJX--p1hB/usercallback',

  // Google Sheets Apps Script - dev.
  'https://script.google.com/macros/d/1w5OdBhoPHPN8Csh5P_BlOlu_rFS1owZceK4KNa1eTI2-JqUe4kAPT-VT/usercallback',

  // Production - GDS 250+ Apps Script
  'https://script.google.com/macros/d/1Cn1gMZHXu_6wftdsgkq_SpAjWBpuNoHrhImSE6QL0KKD1YzjeLMQdo-l/usercallback',

  // Non production - testing - GDS 250+ Apps Script
  'https://script.google.com/macros/d/1A7Qb_vjmVhuuukbQOxe7_5hMhdepyfZR4fSU0oKgl3BwaWySEXobs7XO/usercallback',

  // TapAccess Smart Connector redirector - TapClicks-owned, env-independent.
  'https://im.tapclicks.com/oauthredirector.php',

  // Compulse (Media Planner)
  'https://backend.admin.adportal.io/accounts/tapclicks/login/callback/',

  // Compulse (Media Planner) Non-Prod
  'https://backend.admin.stg.adportal.io/accounts/tapclicks/login/callback/',
];
